import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProgressBar, ProgressBarStyle } from 'primeng/progressbar';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-progress-bar',
  templateUrl: './m-progress-bar.component.html',
  styleUrls: ['./m-progress-bar.component.scss'],
  providers: [ProgressBarStyle],
  imports: [ProgressBar]
})
export class MProgressBarComponent extends ProgressBar {
  @Input() inverted = false;
  @Input() compare = false;

  // PrimeNG 20 applies the root host class via `host: { '[class]': "cn(cx('root'), styleClass)" }`.
  // This wrapper renders its OWN inner <p-progressBar>, so the class is inherited onto
  // <m-progress-bar> too — duplicating styling. Neutralize on the wrapper host.
  override cx(): string {
    return '';
  }

  get extendedStyleClass(): string {
    return `${this.styleClass || ''} ${this.compare ? 'compare' : ''} ${
      this.inverted ? 'inverted' : ''
    }`;
  }
}
